module.exports = __webpack_public_path__ + "static/media/rambu fruit no bgWEB.8f62e492.png";